import { getIntegrationKey } from './getIntegrationKey';
import { getFlowKey } from './getFlowKey';
export const getIntegrationOrFlowKey = () => {
  return getIntegrationKey() || getFlowKey();
};